export const receiveBoardDetails = (state, { payload: { boardId } }) => ({
  ...state,
  boardId
});
